// extracted by mini-css-extract-plugin
export var externalLink = "_93-0";
export var internalLinkLabel = "_93-1";